export default __webpack_public_path__ + "static/media/LYD-AVAX.2cceb0da.png";